import React, { Component } from 'react';
import { Link } from "react-router-dom";

class FooterCategoryWidget extends Component {
    state = {
        title: 'Make money with us',
        links: [
            {
                path: '/',
                text: 'Sell on Katika U.S.'
            },
            {
                path: '/',
                text: 'Sell on Katika Africa'
            },
            {
                path: '/',
                text: 'List your business'
            },
            {
                path: '/',
                text: 'Become an Ambassador'
            },
            {
                path: '/',
                text: 'Self-Publish with Us'
            }
        ]
    }
    render() {
        return (
            <>
                <div className="col-lg-2 col-md-2 col-sm-2 column-td-6">
                    <div className="footer-item">
                        <h4 className="footer__title">
                            {this.state.title}
                        </h4>
                        <ul className="list-items">
                            {this.state.links.map((link, index) => {
                                return (
                                    <li key={index}>
                                        <Link to={link.path}>{link.text}</Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export default FooterCategoryWidget;